export default __webpack_public_path__ + "static/media/Ganapathi-modified.0c05d180.png";